export const ArrangeFormItem = {
  SORT_ORDER: 'Sort order',
  DATES: 'Dates',
  MIN_VALUE: 'Min value',
  MAX_VALUE: 'Max value',
  SELECTED_ITEMS: 'Selected items',
  SEARCH: 'Search',
  CHOSEN_ITEM: 'Chosen item',
};
